import { addValidator } from 'redux-form-validators';

export const totalLimitValidator = addValidator({
  validator: function (options, value, allValues) {
    if (options.total < Number(allValues.foodLimit ?? 0) + Number(allValues.transportLimit ?? 0)) {
      return {
        id: 'form.errors.custom',
        defaultMessage: ' '
      };
    }
  }
});

export const requireIfAnyUsed = addValidator({
  validator: function (options, value, allValues) {
    if (!value && (allValues.foodLimit ? true : !!allValues.transportLimit)) {
      return {
        id: 'form.errors.custom',
        defaultMessage: options.errorMsg
      };
    }
  }
});
